import styled from "styled-components";

export default styled.div`
  display: flex;
  gap: 15px;
  @media(max-width: 500px) {
    flex-direction: column;
    width: calc(100% - 30px);
  }
`;
